import { Inertia } from "@inertiajs/inertia";
//initial state
const state = () => ({
    isLoading: false,
})

//getters
const getters = {
    getIsLoading(state) {
      return state.isLoading;
    },
}

// actions
const actions = {
    setNewUser({dispatch,commit, state}, newUser) {
        commit('setIsLoading', true)
        Inertia.post('/api/users-create', newUser , {
            onFinish: visit => {
                Inertia.visit(location.pathname)
            },
            onSuccess: visit => {
                commit('setNotification', {
                    title: `${visit.props.flash.response === 'success' ? '¡Creación exitosa!' : '¡Creación fallida!'}`,
                    msg: visit.props.flash.response === 'success' ? `El usuario Se ha creado correctamente.`: visit.props.flash.response,
                    filled: true,
                    success: visit.props.flash.response === 'success' ? true : false,
                    error: visit.props.flash.response === 'success' ? false : true,
                    active: true,
                  },{root: true});
                  setTimeout(() => dispatch('closeNotification', {}, {root: true}), 5000);
                  commit('setIsLoading', false)
            }
        })
    },
    editUser({dispatch,commit, state}, user) {
        commit('setIsLoading', true)
        Inertia.put('/api/users-edit',  user , {
            preserveState: false,
            preserveScroll: true,
            onFinish: visit => {
                Inertia.visit(location.pathname)
            },
            onSuccess: visit => {
                commit('setNotification', {
                    title: `${visit.props.flash.response === 'success' ? '¡Edición exitosa!' : '¡Edición fallida!'}`,
                    msg: visit.props.flash.response === 'success' ? `El usuario Se ha modificado correctamente.`: visit.props.flash.response,
                    filled: true,
                    success: visit.props.flash.response === 'success' ? true : false,
                    error: visit.props.flash.response === 'success' ? false : true,
                    active: true,
                  }, {root: true});
                  setTimeout(() => dispatch('closeNotification', {}, {root: true}), 5000);
                  commit('setIsLoading', false)
            }
        })
    },
    deleteUser({dispatch,commit, state}, id) {
        commit('setIsLoading', true);
        Inertia.post('/api/users-delete',  { id: id } , {
            onFinish: visit => {
                Inertia.visit(location.pathname)
            },
            onSuccess: visit => {
                commit('setNotification', {
                    title: `${visit.props.flash.response === 'success' ? '¡Edición exitosa!' : '¡Edición fallida!'}`,
                    msg: visit.props.flash.response === 'success' ? `El usuario Se ha creado correctamente.`: visit.props.flash.response,
                    filled: true,
                    success: visit.props.flash.response === 'success' ? true : false,
                    error: visit.props.flash.response === 'success' ? false : true,
                    active: true,
                  },{root: true});
                  setTimeout(() => dispatch('closeNotification', {}, {root: true}), 5000);
                  commit('setIsLoading', false)
            }
        })
    },
}

//mutations
const mutations = {
    setIsLoading: (state, newValue) => {
      state.isLoading = newValue;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}